
import React from "react";
import { Button } from "@/components/ui/button";
import { Calendar, CalendarCheck } from "lucide-react";

interface RecebimentosTabActionsProps {
  onAgendarRecebimento: () => void;
  onRegistrarRecebimento: () => void;
}

const RecebimentosTabActions: React.FC<RecebimentosTabActionsProps> = ({
  onAgendarRecebimento,
  onRegistrarRecebimento
}) => {
  return (
    <div className="flex flex-wrap gap-2 mt-4 md:mt-0">
      <Button 
        onClick={onAgendarRecebimento}
        className="bg-financeiro-accent-DEFAULT hover:bg-financeiro-accent-dark"
      >
        <Calendar className="h-4 w-4 mr-2" /> Agendar Recebimento
      </Button>
      <Button 
        variant="outline" 
        onClick={onRegistrarRecebimento}
        className="border-financeiro-border-DEFAULT text-financeiro-text-DEFAULT"
      >
        <CalendarCheck className="h-4 w-4 mr-2" /> Registrar Recebimento
      </Button>
    </div>
  );
};

export default RecebimentosTabActions;
